import type React from "react";
import { Search } from "react-bootstrap-icons";
import { Link } from "react-router-dom";
import { Modal } from "@/components/Modals";
import { useAuth } from "@/hooks/useAuth";
import useConfig, { TEMPLATES_PROPOUNDING_FF } from "@/hooks/useConfig";
import UploadIcon from "@/images/icon-propound-upload.svg?react";
import styles from "./PropoundSelectionModal.module.scss";

export default function PropoundSelectionModal({
  isShow,
  onClose,
  handleQuickActionUpload,
  setShowPropoundIntroModal,
  setIsPleadingUpload,
}: {
  isShow: boolean;
  onClose: () => void;
  handleQuickActionModal: () => void;
  handleQuickActionUpload: (e: React.MouseEvent) => void;
  setShowPropoundIntroModal: React.Dispatch<React.SetStateAction<boolean>>;
  setIsPleadingUpload: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const { user, firm } = useAuth();
  const [, featureFlags] = useConfig();
  const useTemplatesOnlyPropounding = featureFlags()[TEMPLATES_PROPOUNDING_FF]
    ? featureFlags()[TEMPLATES_PROPOUNDING_FF](user, firm)
    : false;
  function showQuickActionUploadModal(e: React.MouseEvent) {
    handleQuickActionUpload(e);
    setIsPleadingUpload(true);
  }

  return (
    <Modal
      show={isShow}
      onClose={onClose}
      onConfirm={() => setShowPropoundIntroModal(false)}
      showConfirmButton={false}
      showCancelButton={false}
    >
      <div className={styles.propoundSelection}>
        <h2>How would you like to start?</h2>
        <button
          type="button"
          onClick={showQuickActionUploadModal}
          className={styles.propoundSelectionItem}
        >
          <div className={styles.iconContainer}>
            <UploadIcon className={styles.uploadIcon} />
          </div>
          Upload a Pleading PDF
        </button>

        {useTemplatesOnlyPropounding && (
          <Link to="/cases" className={styles.propoundSelectionItem}>
            <div className={styles.iconContainer}>
              <Search size={20} color="var(--primary-1)" />
            </div>
            Choose or Create a Case
          </Link>
        )}
      </div>
    </Modal>
  );
}
